export function normalizePartnerCode(
  value: string | null | undefined
): string | null {
  if (value == null) return null;
  const normalized = value.trim().toLowerCase();
  return normalized.length > 0 ? normalized : null;
}

export function firstTouchPartnerCode(
  partnerQuery: string | null,
  hasExistingCookie: boolean
): string | null {
  if (hasExistingCookie) return null;
  return normalizePartnerCode(partnerQuery);
}

export function assertPartnerFields(code: string, label: string): void {
  if (code.length === 0) {
    throw new Error('Partner code is required');
  }
  if (!/^[a-z0-9-]+$/.test(code)) {
    throw new Error(
      'Partner code may only contain lowercase letters, numbers, and hyphens'
    );
  }
  if (label.length === 0) {
    throw new Error('Partner label is required');
  }
  if (label.length > 128) {
    throw new Error('Partner label must be 128 characters or fewer');
  }
}
